import PropTypes from 'prop-types';

import c24DefaultLogo from '../../../assets/HORIZON_oneline.png';

function Crisis24Logo(props) {
  const {logo = c24DefaultLogo} = props;

  return <img src={logo} alt="Crisis24 Horizon Logo" />;
}

Crisis24Logo.propTypes = {
  logo: PropTypes.string,
};

export default Crisis24Logo;
